import { type PriceData } from "~/domains/pricing/types/PriceData";
import { type PackagingInformationEntry, type WarehouseStockData } from "~/domains/product/types/ProductData";

export function isValidQuantity(packSize: number | undefined, quantity?: number) {
  if (!quantity || packSize === undefined) {
    return true;
  }
  return quantity > 0 && Number.isInteger(quantity / packSize);
}

export function isOfferPriceValid(offerPrice: PriceData, msp?: PriceData) {
  if (!msp) {
    return true;
  }
  return offerPrice.value >= msp.value;
}

export function getAllWarehouses(packaging: PackagingInformationEntry) {
  return [packaging.totalWarehouse];
}

export function hasInStock(packaging: PackagingInformationEntry) {
  return getAllWarehouses(packaging)
    .flatMap((wh) => wh.inStock)
    .some((x) => x.quantity > 0);
}

export function hasInProduction(packaging: PackagingInformationEntry) {
  return getAllWarehouses(packaging).some((x) => x.inProduction.length > 0);
}

export function hasInClarification(packaging: PackagingInformationEntry) {
  return getAllWarehouses(packaging).some((x) => x.inClarification > 0);
}

export function getInStock(packaging: PackagingInformationEntry) {
  return getAllWarehouses(packaging)
    .flatMap((wh) => wh.inStock)
    .reduce((acc, x) => acc + x.quantity, 0);
}

/**
 * Provides the total stock for a given packaging.
 * This includes in stock, in production and in clarification
 * @param packaging
 */
export function getTotalStock(packaging: PackagingInformationEntry) {
  return getAllWarehouses(packaging).reduce((acc, x) => acc + getTotalStockOfWarehouse(x), 0);
}

function getTotalStockOfWarehouse(warehouse: WarehouseStockData) {
  return (
    warehouse.inClarification +
    [...warehouse.inStock, ...warehouse.inProduction].reduce((acc, x) => acc + x.quantity, 0)
  );
}
